import React, { useEffect, useState } from "react";

import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Unstable_Grid2';
import Cardmetrice from "../common/Cardmetrice";
import Accordian from "../common/Accordian";

const Home = (props) => {
  return (
    <div className="home">
      <p style={{color:"#748076"}}>ProEngage</p>
      <Box   sx={{ flexGrow: 1 }}>
        <Grid container spacing={1} rowSpacing={1} columns={12}>
          <Grid xs={8} md={8}>
           <Accordian/>
          </Grid>
          <Grid xs={4} md={4}>
            <Cardmetrice/>
          </Grid>
        </Grid>
      </Box>
    </div>
  )

}

export default Home;


